export enum ServiceItemType {
  FIRM = "firm",
  SERVICE = "service",
  PRODUCT = "product",
  SECONDMENT = "secondment"
}
